var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tuobu"},[_c('div',{staticClass:"tonav"},[_c('diV')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }